export default __webpack_public_path__ + "static/media/sign_in_for_dark_personal.d1e70b7f.svg";